// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomCartItem-module__container___2pD_f","visible":"BottomCartItem-module__visible___4eA6x","hidden":"BottomCartItem-module__hidden___3SKNQ"};